import { styled } from '../../../lib/stitches'
import Button from '../../core/Button/Button'
import withTooltip from '../../core/withTooltip'
import { gray10, gray15, gray3, gray4 } from '../../platform/color'

export const StyledButton = styled('button', {
  padding: '6px',
  border: 'none',
  borderRadius: '100%',
  height: '32px',
  width: '32px',
  display: 'flex',
  color: gray15,
  alignItems: 'center',
  backgroundColor: 'transparent',
  transition: 'background-color 0.1s ease-in-out',
  justifyContent: 'center',
  '&:hover:enabled': {
    backgroundColor: gray4
  },
  '&:disabled': {
    cursor: 'not-allowed'
  },
  '&:disabled svg': {
    color: gray10
  }
})

export const StudioTab = styled('div', {
  fontSize: '14px',
  padding: '10px 10px 10px 10px',
  marginRigth: '5px',
  borderBottom: '3px solid transparent',
  cursor: 'pointer',
  '&:hover': {
    borderBottomColor: 'var(--studio-very-dark)'
  },
  variants: {
    active: {
      true: {
        borderBottomColor: '#e2e2e9'
      }
    }
  }
})

const CURSOR = 'ew-resize !important'

const StyledTempoContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '16px',
  marginRight: '16px'
})

const StyledLabel = styled('label', {
  marginRight: '8px',
  fontSize: '14px',
  lineHeight: '15px',
  color: 'rgba(0,0,0,.5)',
  variants: {
    dark: {
      true: {
        color: gray15,
        fontWeight: 500
      }
    }
  }
})

export const INPUT_CONTAINER_BACKGROUND_COLOR = 'rgba(0,0,0,.05)'

const StyledInputContainer = styled('div', {
  backgroundColor: INPUT_CONTAINER_BACKGROUND_COLOR,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6px',
  padding: '5px 3px 5px 7px',
  color: gray15,
  variants: {
    moreRound: {
      true: {
        borderRadius: '8px'
      }
    }
  }
})

const StyledInput = styled('input', {
  fontFamily: 'Azeret Mono',
  border: 'none',
  background: 'none',
  textDecoration: 'none',
  outline: 'none',
  padding: '0',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '-1px',
  fontWeight: 300,
  maxWidth: '28px'
})

const StyledDragWrapper = styled('div', {
  userSelect: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: CURSOR,
  appearance: 'none',
  border: 'none'
})

const StyledInputContainerButton = styled(Button, {
  marginRight: '5px',
  padding: '0px 4px',
  border: `1px solid ${gray3}`
})

export const InputContainer = StyledInputContainer
export const InputContainerButton = withTooltip(StyledInputContainerButton)
export const DragWrapper = StyledDragWrapper
export const Input = StyledInput
export const TempoContainer = StyledTempoContainer
export const Label = StyledLabel
export const LabelWithTooltip = withTooltip(Label)
